var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"lock-screen-btn-con",on:{"click":_vm.lock}},[_c('Tooltip',{attrs:{"content":_vm.L('LockScreen'),"placement":"bottom"}},[_c('i',{staticClass:"iconfont",staticStyle:{"font-size":"20px"}},[_vm._v("")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }